/**
 * Created by TapFun on 2024/12/02.
 */
import qs from 'qs';
import {SERVER_HOST} from '../common/portConfig';
import request from '@/common/request'

// 获取图片验证码
export const reqCodeImg = params => {
    return request.get(`/admin/getCodeImage`, {
        params: params,
        responseType: 'blob'
    })
};

// 调剂员角色用户登录接口
export const reqSystemLogin = params => {
    return request.post(`/admin/login`, qs.stringify(params)).then(res => res.data)
};

// 非调剂员角色用户登录接口
export const reqLoginForOthers = params => {
    return request.post(`/admin/loginForOthers`, qs.stringify(params)).then(res => res.data)
};

// 左侧菜单列表
export const reqGetLeftMenus = params => {
    return request.get(`/admin/permission/leftMenu`, {
        params: params
    })
};

// 角色分页
export const reqGetRoleListPage = params => {
    return request.get(`/admin/role/pageQuery`, {
        params: params
    })
};

// 添加角色
export const reqAddRole = params => {
    return request.post(`/admin/role/add`, qs.stringify(params))
};

// 编辑角色
export const reqEditRole = params => {
    return request.post(`/admin/role/edit`, qs.stringify(params))
};

// 删除角色
export const reqDeleteRole = params => {
    return request.get(`/admin/role/del`, {
        params: params
    })
};

// 根据id查询角色信息
export const reqGetRoleById = params => {
    return request.get(`/admin/role/queryById`, {
        params: params
    })
};

// 获取角色列表
export const reqGetRoleList = params => {
    return request.get(`/admin/role/list`, {
        params: params
    })
};

// 用户管理 - 导出
export const reqExportUser = params => {
    return request.post(`/admin/user/export`, params, {responseType: 'blob'})
}


// 用户修改密码
export const updateUserPwd = params => {
    return request.post(`/admin/user/updatePwd`, params)
};

// 用户列表
export const reqGetUserListPage = params => {
    return request.get(`/admin/user/page`, {
        params: params
    })
};

// 添加用户
export const reqAddUser = params => {
    return request.post(`/admin/user/add`, params)
};

// 用户禁用/启用
export const reqEditUserStatus = params => {
    return request.post(`/admin/user/editStatus`, qs.stringify(params))
};

// 根据id查询用户信息
export const reqGetUserById = params => {
    return request.get(`/admin/user/one`, {
        params: params
    })
};

// 编辑用户
export const reqEditUserData = params => {
    return request.post(`/admin/user/edit`, params)
};

// 删除用户
export const reqDeleteUser = params => {
    return request.delete(`/admin/user/del`, {
        params: params
    })
};

// 重置密码
export const reqResetPassword = params => {
    return request.get(`/admin/user/resetPassword`, {
        params: params
    })
};

// 查询用户列表
export const reqGetUserList = params => {
    return request.get(`/admin/user/list`, {
        params: params
    })
};

// 权限列表
export const queryPermissions = params => {
    return request.get(`/admin/permission/queryPermissions`, {
        params: params
    })
};

// 按钮权限
export const reqGetPermissionButton = params => {
    return request.get(`/admin/permission/queryPermissionButton`, {
        params: params
    })
};

// 权限编辑
export const reqEditRolePermission = params => {
    return request.post(`/admin/role/updatePermission`, qs.stringify(params))
};

// 数据字典列表
export const reqGetDictionaryList = params => {
    return request.get(`/admin/dictionary/list`, {
        params: params
    })
};

// 数据字典根节点分页查询
export const reqGetDictionaryPageList = params => {
    return request.get(`/admin/dictionary/pageList`, {
        params: params
    })
};

// 根据父级id查询所有子节点
export const reqGetDictionaryChildren = params => {
    return request.get(`/admin/dictionary/children`, {
        params: params
    })
};

// 数据字典父级列表
export const reqGetDictionaryParentList = params => {
    return request.get(`/admin/dictionary/getParentList`, {
        params: params
    })
};

// 数据字典添加
export const reqAddDictionary = params => {
    return request.post(`/admin/dictionary/add`, params)
};

// 数据字典删除
export const reqDeleteDictionary = params => {
    return request.delete(`/admin/dictionary/delete/` + params.id, params)
};

// 通过code查询可用的数据字典选项
export const reqGetDictionaryListByCode = params => {
    return request.get(`/admin/dictionary/getListByCode`, {
        params: params
    })
};

// 通过code查询所有数据字典选项
export const reqGetAllDictionaryListByCode = params => {
    return request.get(`/admin/dictionary/getAllListByCode`, {
        params: params
    })
};

// 通过id查询数据字典信息
export const reqGetDictionaryOne = params => {
    return request.get(`/admin/dictionary/one`, {
        params: params
    })
};

// 数据字典编辑
export const reqEditDictionary = params => {
    return request.post(`/admin/dictionary/edit`, params)
};

// 文件上传
export const uploadFileURL = `${SERVER_HOST}admin/uploadFile`;

// 文件删除
export const reqDeleteFiles = params => {
    return request.post(`/admin/deleteFiles`, params)
};

// 文件下载，需提供token
export const downloadFile = params => {
    return request.get(`/admin/downloadFile`, {
        params: params,
        responseType: 'blob'
    })
};

// 通过code列表查询可用的数据字典选项map
export const reqDictionaryMapByCodeList = params =>{
    return request.post(`/admin/dictionary/getMapByCodeList`, params)
}

// 登录日志分页查询
export const reqGetLogListPage = params => {
    return request.get(`/admin/loginLog/page`, {
        params: params
    })
};
// 操作日志分页查询
export const reqGetOperationLogList = params => {
    return request.get(`/admin/operationLog/page`, {
        params: params
    })
};
// 根据类型查询审核流程信息
export const reqGetProcessByType = params =>{
    return request.get(`/admin/process/byType`,{
        params: params
    })
}
// 审核流程编辑
export const reqEditProcess = params =>{
    return request.post(`/admin/process/edit`,params)
}
// 供应商 - 导入
export const reqVerifyAndSaveSupplierImport = `${SERVER_HOST}admin/supplier/verifyAndSave`;
// 供应商管理 - 分页查询
export const reqGetSupplierPage = params => {
    return request.get(`/admin/supplier/page`, {
        params: params
    })
};
// 物资类 - 导入
export const reqImportCategory = `${SERVER_HOST}admin/category/importing`;

// 供应商管理 - 根据id查询信息
export const reqGetSupplierById = params => {
    return request.get(`/admin/supplier/one`, {
        params: params
    })
};

// 供应商管理 - 编辑
export const reqEditSupplier = params => {
    return request.post(`/admin/supplier/edit`, params)
};

// 企业类型 - 选项列表
export const reqGetBusinessOptions = params => {
    return request.get(`/admin/types/businessOptions`, {
        params: params
    })
};

// 币种类型 - 选项列表
export const reqGetCurrencyOptions = params => {
    return request.get(`/admin/types/currencyOptions`, {
        params: params
    })
};

// 经营品类 - 选项列表
// export const reqGetCategoryOptions = params => {
//     return request.get(`/admin/types/CategoryOptions`, {
//         params: params
//     })
// };

// 物资类管理 - 分页查询
export const reqGetCategoryPage = params => {
    return request.get(`/admin/category/page`, {
        params: params
    })
};

// 物资类管理 - 根据id查询信息
export const reqGetCategoryById = params => {
    return request.get(`/admin/category/one`, {
        params: params
    })
};

// 站内信息 - 分页查询
export const reqGetNoticePage = params => {
    return request.get(`/admin/notice/page`, {
        params: params
    })
};

// 物资类管理 - 选项列表
export const reqGetCategoryOptions = params => {
    return request.get(`/admin/category/options`, {
        params: params
    })
};

// 根据id查询站内信息
export const reqGetNoticeById = params => {
    return request.get(`/admin/notice/one`, {
        params: params
    })
};

// 查询采购询价类型选项列表
export const reqGetInquiryTypeOptions = params => {
    return request.get(`/admin/types/inquiry/Options`, {
        params: params
    })
};

// 根据大类code查询相关的供应商列表，包含全品类供应商
export const reqGetMatchedSuppliers = params => {
    return request.post(`/admin/supplier/matched`, params)
};

// 采购管理 - 分页查询
export const reqGetInquiryrPage = params => {
    return request.get(`/admin/inquiry/page`, {
        params: params
    })
};

// 计划编号 - 选项列表
export const reqGetPlanOptions = params => {
    return request.get(`/admin/inquiry/options`, {
        params: params
    })
};

// 获取供应商列表
export const reqGetSupplierList = params => {
    return request.get(`/admin/supplier/options`, {
        params: params
    })
};

// 根据角色编码查询用户列表
export const reqGetUsersByRoleCode = params => {
    return request.get(`/admin/user/byRoleCode`, {
        params: params
    })
};
